
































import Vue from "vue"
import BreadcrumbContainer from "~/components/guideline/breadcrumb/BreadcrumbContainer.vue"
import Breadcrumb, {
  BreadcrumbItem,
} from "~/components/guideline/breadcrumb/Breadcrumb.vue"
import CProfileDetailForCorporation from "~/components/custom/profileDetail/CProfileDetailForCorporation.vue"
import CProfileDetailForMyPage from "~/components/custom/profileDetail/CProfileDetailForMyPage.vue"
import CProfileDetailForPublic from "~/components/custom/profileDetail/CProfileDetailForPublic.vue"
import { BackendApi } from "~/backendApis"
import {
  UserProfileSearchResultView,
  decorateUserProfileSearchResultView,
  FullInfoUserProfileView,
} from "~/backendApis/viewModel"
import ProgressCircular from "~/components/guideline/loading/ProgressCircular.vue"
import CShouldApealPaidPlanAlert from "~/components/custom/alert/CShouldApealPaidPlanAlert.vue"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"

interface DataType {
  userProfile: UserProfileSearchResultView | null
}

// TODO : このコンポーネントで使うプロフィール情報を整理する
export default Vue.extend({
  components: {
    BreadcrumbContainer,
    Breadcrumb,
    CProfileDetailForCorporation,
    CProfileDetailForMyPage,
    CProfileDetailForPublic,
    ProgressCircular,
    CShouldApealPaidPlanAlert,
  },
  layout: "application",
  validate({ params }) {
    return params.userId !== undefined && /^[a-zA-Z0-9]+$/.test(params.userId)
  },
  data(): DataType {
    return {
      userProfile: null,
    }
  },
  async fetch() {
    // SEO用
    // 認証前は見れず、ブラウザ側での認証後に見れる場合もあるので、該当するプロフィールが取得できないでも404にするようなことはしていない。
    // TODO: IP制限を顧慮して、stg環境では一時的にCSR時にAPIを呼ぶようにしていので、IP周りの問題が解消したら修正する。
    const appEnv = process.env.APP_ENV
    if (appEnv === "staging") {
      if (process.client) {
        this.userProfile = await BackendApi.general.userProfileSearch.read.getUserProfile(
          {
            universalUid: this.userId,
          }
        )
      }
    } else if (process.server) {
      // staging環境以外ではSSR時に呼ぶ。
      this.userProfile = await BackendApi.general.userProfileSearch.read.getUserProfile(
        {
          universalUid: this.userId,
        }
      )
    }
  },
  head(): object {
    const appEnv = process.env.APP_ENV
    const backendFileAPIBaseURL = process.env.BACKEND_FILE_API_BASE_URL
    const ogpImageUrl =
      appEnv === "production" // OGPは本番環境でのみ表示。ステージングはファイルAPI側がIP制限の関係でOGPの生成に対応していないため。
        ? `${backendFileAPIBaseURL}/profile_ogp/${this.userId}`
        : undefined

    if (this.userProfile) {
      const fullName = decorateUserProfileSearchResultView(
        this.userProfile
      ).getFullName()
      return this.$clHelpers.metaTag.generate({
        title: `${fullName}さんのプロフィール`,
        currentPath: this.$nuxt.$route.path,
        ogpImageUrl,
        noIndex: true,
      })
    }

    return this.$clHelpers.metaTag.generate({
      title: "ユーザープロフィール",
      currentPath: this.$nuxt.$route.path,
      ogpImageUrl,
      noIndex: true,
    })
  },
  computed: {
    breadcrumbItems(): BreadcrumbItem[] {
      return [
        {
          href: "/profiles",
          text: "プロフィール一覧",
        },
        { text: "プロフィール詳細" },
      ]
    },
    isUserMypage(): boolean {
      return this.$clAuth.loggedIn && this.$clAuth.userIdOrFail === this.userId
    },
    userId(): string {
      return this.$route.params.userId
    },
    finishedAuthProcess(): boolean {
      return this.$clAuth.finishedAuthProcess
    },
    currentUserProfile(): FullInfoUserProfileView | null {
      return this.$clAuth.userProfile
    },
    isAvailableScout(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.USER_SCOUT)
    },
  },
  watch: {
    finishedAuthProcess: {
      async handler() {
        if (!this.finishedAuthProcess) {
          return
        }

        /**
         * 認証がブラウザ側での画面描画のタイミングで行われる仕様上、その認証処理を待たないと表示しているプロフィール画面がマイページなのかどうかが判定できない。
         * そのため、認証終了後にナビゲーションバーの状態も更新するようにしている。
         */
        this.updateNavigationBarStatus()

        // SSRでプロフィールを取得できていない場合のみ、クライアント側で認証完了後に改めてプロフィールの取得を試みる。
        if (!this.userProfile) {
          this.userProfile = await this.$clStores.profileSearchList.getters.getProfileByIdFromListOrRemote(
            this.userId
          )
        }

        if (!this.userProfile) {
          this.$nuxt.error({
            statusCode: 404,
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateNavigationBarStatus() {
      if (this.isUserMypage) {
        this.$clStores.mobileNavigationMenu.actions.changeState({
          pageTitle: "マイページ",
          isVisibleBottomNav: true,
        })
      } else {
        this.$clStores.mobileNavigationMenu.actions.changeState({
          previousPagePath: "/profiles",
          pageTitle: "プロフィール",
        })
      }
    },
  },
})
